import linkedin_limited_listings_description_1 from 'assets/images/appStore/linkedin_limited_listings/description_1.png'

import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import atsCompanies from 'modules/ats/store/collections/atsCompanies'

import { Description, List, ListEl, Note, Title } from './elements'

const EXAMPLE_COMPANY_ID = <i>1546341</i>

export const LinkedInLimitedListings = () => {
  useEffect(() => {
    atsCompanies.fetch()
  }, [])

  return (
    <>
      <Title>
        {i18n.t('app_store_v2.app_integrations.linkedin_limited_listings.description_view.title_1')}
      </Title>
      <Description>
        {i18n.t(
          'app_store_v2.app_integrations.linkedin_limited_listings.description_view.description_1'
        )}
      </Description>
      <Title>
        {i18n.t('app_store_v2.app_integrations.linkedin_limited_listings.description_view.title_2')}
      </Title>
      <Description>
        {i18n.t(
          'app_store_v2.app_integrations.linkedin_limited_listings.description_view.description_2'
        )}
      </Description>
      <List>
        <ListEl>
          {i18n.t(
            'app_store_v2.app_integrations.linkedin_limited_listings.description_view.list_1.1'
          )}
        </ListEl>
        <ListEl>
          {i18n.t(
            'app_store_v2.app_integrations.linkedin_limited_listings.description_view.list_1.2'
          )}
        </ListEl>
        <ListEl>
          {i18n.t(
            'app_store_v2.app_integrations.linkedin_limited_listings.description_view.list_1.3'
          )}
        </ListEl>
        <img src={linkedin_limited_listings_description_1} />
        <ListEl>
          {i18n.t(
            'app_store_v2.app_integrations.linkedin_limited_listings.description_view.list_1.4'
          )}
        </ListEl>
        <ListEl>
          {i18n.tView(
            'app_store_v2.app_integrations.linkedin_limited_listings.description_view.list_1.5',
            {
              company_id: EXAMPLE_COMPANY_ID,

              sample: (
                <Note>
                  {i18n.tView(
                    'app_store_v2.app_integrations.linkedin_limited_listings.description_view.list_1.sample',
                    {
                      company_id: EXAMPLE_COMPANY_ID,
                    }
                  )}
                </Note>
              ),
            }
          )}
        </ListEl>
        <ListEl>
          {i18n.tView(
            'app_store_v2.app_integrations.linkedin_limited_listings.description_view.list_1.6',
            {
              sample2: (
                <Note>
                  {i18n.tView(
                    'app_store_v2.app_integrations.linkedin_limited_listings.description_view.list_1.sample2',
                    {
                      company_id: EXAMPLE_COMPANY_ID,
                    }
                  )}
                </Note>
              ),
            }
          )}
        </ListEl>
      </List>
      <Description>
        {i18n.t(
          'app_store_v2.app_integrations.linkedin_limited_listings.description_view.description_3'
        )}
      </Description>
      <List>
        <ListEl>
          {i18n.t(
            'app_store_v2.app_integrations.linkedin_limited_listings.description_view.list_2.1'
          )}
        </ListEl>
        <ListEl>
          {i18n.t(
            'app_store_v2.app_integrations.linkedin_limited_listings.description_view.list_2.2'
          )}
        </ListEl>
      </List>
    </>
  )
}
